import CardReports from "./card-reports";

export default CardReports;
